import * as clickEvents from './clickEvents'

export default { clickEvents }
